module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAABBBAMAAAB82dR2AAAAElBMVEUAAAAAAAAAAAAAAAAAAAAAAADgKxmiAAAABXRSTlMAYO8wn+QF3gkAAAC9SURBVHhehdYxCoVADIbBeIPHA3sbe/EENh7AIve/ipB24DfdR2DQ3Wbr/FWa/1H7U2GW3mrtgMx26YDMMiKzA4EAgQCBAIEAgQCBAIEAgQCBAJEQkRCxByFFKBBCBAIEQgQCBEIEAgRCBAIEQgQCBALkHiIhQ6S5+wpANvJ35H/J55HPNN9LJEAgQCBAIEAgQCBAIAgICoKEoCFAIEAgQCBAIEAgQCBAIEAgQCBAIEAgQCBAIEC+3w7f748X4VNHE764UM0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close_b.png
// module id = 8S6z
// module chunks = 1